import { useTranslation } from "react-i18next";
import { LOCALE_FILTER_STORAGE_KEY, useGlobal } from "../../../context/GlobalContext";
import LocalesList from "../../others/LocalesList";
import { useSettings } from "../../../context/SettingsContext";
import EToolTip from "../../others/EToolTip";

const LocaleFilter = () => {

    const { t } = useTranslation();
    const { g } = useGlobal();
    const { settings } = useSettings();

    const handleChange = (opt) => {
        const value = opt?.value ?? '';
        if (value === g.localeFilter) return;

        try {
            localStorage.setItem(LOCALE_FILTER_STORAGE_KEY, value);
        } catch {
            /* private mode / quota */
        }

        window.location.reload();
    }
 
    if (!(settings?.site?.locales?.trim()||null)) return null;

    return (
        <EToolTip title={t('LocaleFilter.title')}
            placement="right"> 
        <div className="ps-3 text-start"  
            style={{minWidth:'100px', width:'100%'}}>
            <LocalesList
                onChange={handleChange}
                emptyTitle={t('LocaleFilter.allLocales')}
                value={g.localeFilter}/>
            
        </div>
        </EToolTip>)    
}

export default LocaleFilter;
 